import { SiNoEnum } from "../enum/si-no-enum";
import { VersioneFuturaVO } from "./versione-futuraVO";
import { CampoSpecificoConservazioneVO } from "./campo-specifico-conservazioneVO";
import { CampoSpecificoFascicolazioneVO } from "./campo-specifico-fascicolazioneVO";
import { ValoriDefaultDocumentoVO } from "./valori-default-documentoVO";

export class TipologiaDocumentoVO {
  id: string;

  nome: string;

  codice: string;

  descrizione: string;

  anniConservazioneDaChiusura: number;

  perSempre: boolean;

  ereditaDaFascicolo: boolean;

  motivazione: string;

  dataManuale: SiNoEnum;

  dataAttivazione: string;

  dataModifica: string;

  dataCessazione: string;

  valoriDefaultDocumento: ValoriDefaultDocumentoVO;

  campiSpecificiFascicolo: CampoSpecificoFascicolazioneVO[];

  campiSpecificiConservazione: CampoSpecificoConservazioneVO[];

  versioneFutura: VersioneFuturaVO;

  output: string;
}
